//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'PaduaScore',
  data() {
    return {
      defaultJson:{
        "Heart and\/or respiratory Failure": "循环和\/或呼吸衰竭",
        "Thrombophilic condition": "血栓形成易化条件",
        "vteHint": "既往肺栓塞或深静脉血栓史，并排除浅静脉血栓。",
        "Acute myocardial infarction or ischemic stroke": "急性心肌梗死或缺血性脑卒中",
        "Age ≥70 years": "年龄 ≥ 70 岁",
        "Obesity (BMI ≥30)": "肥胖（BMI ≥ 30）",
        "Previous VTE": "既往静脉血栓栓塞史",
        "Acute infection and\/or rheumatologic disorder": "急性感染和\/或风湿疾病",
        "cancerHint": "局部或远处转移癌症患者和\/或 6 月内接收过放、化疗。",
        "Reduced mobility": "活动受限",
        "mobilityHint": "除上卫生间外持续卧床 3 天以上（无论患者自身限制所致或医生要求）",
        "Ongoing hormonal treatment": "接收激素治疗中",
        "Surgery\/trauma ≤1 month": "手术\/外伤 ≤ 1 月",
        "thrombophilicHint": "抗凝血酶缺陷、蛋白 C 或蛋白 S 突变、Leiden V 因子突变、G20210A 凝血酶原突变，抗磷脂抗体综合征患者。",
        "Active cancer": "活动性癌症",
        "High risk": "高危",
        "Low risk": "低危"
      },
      form:{
        age:'0',
        cancer:'0',
        vte:'0',
        mobility:'0',
        thrombophilic:'0',
        surgery:'0',
        heart:'0',
        vasc:'0',
        sepsis:'0',
        bmi:'0',
        hormonal:'0',
      },
      hasScore:false,
      disabled:false,
      Multifocal_Candida_Colonization_hint: "Candida is simultaneously isolated from various noncontagious foci:\n\nfeces\/rectal swabs or\nurine or\nrespiratory or\nskin or\noropharynx\/stomach",
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else { 
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '0'
      } else {
        // 	hormonal + bmi + sepsis + vasc + heart + age + (surgery * 2) + (thrombophilic * 3) + (mobility * 3) + (vte * 3) + (cancer * 3)
        let result = form.hormonal + form.bmi + form.sepsis + form.vasc + form.heart + form.age + (form.surgery * 2) + (form.thrombophilic * 3) + (form.mobility * 3) + (form.vte * 3) + (form.cancer * 3)
        	
        self.hasScore = true
        return String(result)
      }
    }
  },
  
  
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pulm/PaduaScore.vue